
import { createContext } from "react";

import { ParticipantDocument, UpdateDocumentStateResponse } from "@/apis/dtos";
import useGetDocumentStatesByLabel from "@/hooks/data/useGetDocumentStatesByLabel";


export interface IParticipantDocumentStateContext extends Omit<ReturnType<typeof useGetDocumentStatesByLabel>, 'data' | 'total' | 'offset'> {
    data?: ParticipantDocument[];
    updateDocumentState?: (state: ParticipantDocument, redactedFields?: string[], comments?: string) => Promise<UpdateDocumentStateResponse | undefined>
}

export const ParticipantDocumentStateContext = createContext<IParticipantDocumentStateContext>({
    data: undefined,
    updateDocumentState: async () => { return undefined },
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
})